import { FunctionComponent } from 'react';
import AdsWrapper from './ads.style';
import { LAWTALK_ADS_LABEL } from '@shared/values';
import AdsProducts from '@component/AdsProducts';
import AdsAdvantage from '@component/AdsAdvantage';
import QuestionAction from '@component/QuestionAction';
import HeadMetaTag from '@component/HeadMetaTags';
import { MainLayout } from '@component/LayoutContainer';

const Ads: FunctionComponent = () => {
  return (
    <MainLayout>
      <AdsWrapper className="page-layout">
        <HeadMetaTag />
        <h1 className="page-title mobile">{LAWTALK_ADS_LABEL} 소개</h1>
        <div className="adsproducts-wrapper">
          <AdsProducts />
        </div>
        <div className="adsadvantage-wrapper">
          <AdsAdvantage />
        </div>
        {/* <div className="adsemailreceive-wrapper">
        <AdsEmailReceive />
      </div> */}

        <QuestionAction />
      </AdsWrapper>
    </MainLayout>
  );
};

export default Ads;
